import React from 'react'

import { Text } from '@domain-group/suit-theme'

import { useSetState } from '@domain-group/react-hooks'

const defaultState = {
  visible: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

interface SecuredTextProps {
  callbacks?: {
    action?: () => void,
  },
  text: string,
}

type ShowTextParams = {
  e: React.MouseEvent<HTMLButtonElement>,
  callbacks: SecuredTextProps['callbacks'],
  setState: SetState,
}

const showText = (params: ShowTextParams) => {
  const { e, callbacks, setState } = params
  const { action } = callbacks || {}

  e.stopPropagation()

  if (action) action()

  setState({ visible: true })
}

const SecuredText = (props: SecuredTextProps) => {
  const { callbacks, text } = props

  const [state, setState] = useSetState(defaultState)
  const { visible } = state

  if (visible){
    return <Text color="faintGrey" variant="ellipsis">{text}</Text>
  }

  return (
    <Text
      color="faintGrey"
      // @ts-expect-error TS2322
      onClick={e => showText({ e, callbacks, setState })}
      variant="ellipsis"
    >
      ••••••
    </Text>
  )
}

export default SecuredText
